import { CONTATTI_ARTICOLO, RECAPTCHA_KEY, api, hasPerm } from '../../utils'
import { Form, Formik } from 'formik'
import { PAGINEDETAIL, PUBBLICAARTICOLO } from '../../utils/endpoint'
import React, { useEffect, useRef, useState } from 'react'
import { fieldsPubblica, schemaPubblica } from '../../components/forms-utils/utils'

import Breadcrumbs from '../../components/atomic/Breadcrumbs'
import Forms from '../../components/forms-utils/Forms'
import Privacy from '../../components/registrazione/Privacy'
import ReCAPTCHA from 'react-google-recaptcha'
import { useSelector } from 'react-redux'
import { sendGTMData } from '../../utils/gtm'
import { useDropzone } from 'react-dropzone'
import { useRouter } from 'next/router'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const UploadComponent = props => {
  const { setFieldValue } = props

  const [attivo, setAttivo] = useState(false)

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*, .pdf, .doc',
    onDrop: acceptedFiles => {
      setFieldValue('files', props.values.files.concat(acceptedFiles))
      // if(props.values.files.length>2){
      //   setAttivo(true)
      // }else{
      //   console.log(5120*1024)
      //   console.log(acceptedFiles)
      //   let i = 0;
      //   for(i=0;i<acceptedFiles.length; i++){
      //     if(acceptedFiles[i].size <= (5120 * 1024)){
      //       setFieldValue("files", props.values.files.concat(acceptedFiles));
      //     }
      //   }
      // }
    },
  })

  return (
    <div disabled={attivo} className="div-input-file">
      <div disabled={attivo} {...getRootProps({ className: 'dropzone div-input-file-dropzone' })}>
        <input disabled={attivo} className="input-file" {...getInputProps()} />
        <div>
          <p className="input-file__text">Carica qui i tuoi file</p>
        </div>
        <div>
          {props.values.files &&
            props.values.files.map((file, i) => {
              return <li key={i}>{`File:${file.name}`}</li>
            })}
        </div>
      </div>
    </div>
  )
}

const PubblicaArticolo = ({ pagina }) => {
  const utente = useSelector(state => state?.utente?.utente)

  const formRef = useRef()
  let recaptchaRef = useRef(null)

  const router = useRouter()

  const [initialValues, setInitialValues] = useState(fieldsPubblica)

  useEffect(() => {
    if (hasPerm(utente, CONTATTI_ARTICOLO)) {
      let newInitialValues = {
        ruolo: '',
        nome: utente.nome,
        cognome: utente.cognome,
        email: utente.email,
        telefono: '',
        privacy: false,
        commerciale: false,
        profilazione: false,
        titolo: '',
        files: [],
      }
      setInitialValues(newInitialValues)
    }
  }, [])

  const postData = async data => {
    const token = await recaptchaRef.current.executeAsync() //reCAPTCHA

    if (token) {
      const dataform = new FormData()

      data.files.forEach(file => {
        dataform.append('files', file)
      })
      dataform.append('nome', data.nome)
      dataform.append('cognome', data.cognome)
      dataform.append('email', data.email)
      dataform.append('telefono', data.telefono)
      dataform.append('titolo', data.titolo)
      dataform.append('profilazione', data.profilazione)
      dataform.append('commerciale', data.commerciale)
      dataform.append('privacy', data.privacy)
      dataform.append('ruolo', data.ruolo.value)
      api.post(PUBBLICAARTICOLO, dataform).then(response => {
        if (response.data['created']) {
          sendGTMData({
            event: 'GAevent',
            eventID: '13',
            eventCategory: 'form',
            eventAction: 'pubblica_articolo',
          })
          router.push('/pubblica-articolo/success')
        }
      })
    }
  }

  return (
    <>
      <main className="pubblica-articolo-page">
        <header className="pubblica-articolo-page__header">
          <div className="w-container">
            <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
          </div>
        </header>
        <div className="w-container-inner">
          <div className="pubblica-articolo-page__help">
            <h1 className="pubblica-articolo-page__help__title">{pagina.titolo}</h1>
            <div className="row">
              <div className="col-md-8 pubblica-articolo-page__help__text ">
                <p>{pagina.descrizione}</p>
              </div>
            </div>
          </div>
          <div className="contatti-page__form-box">
            <Formik
              innerRef={formRef}
              enableReinitialize={true}
              initialValues={{
                ...initialValues,
              }}
              validationSchema={schemaPubblica}
              onSubmit={(values, actions) => {
                postData(values)
              }}
            >
              {({ validateForm, resetForm, handleSubmit, setFieldValue, ...formik }) => (
                <>
                  <Form className="w-form" onSubmit={handleSubmit}>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      size="invisible"
                      sitekey={RECAPTCHA_KEY}
                      // onChange={onChange}
                    />
                    <Forms formik={formik} key={1} articolo={true} />
                    <div className="form-group">
                      <UploadComponent setFieldValue={setFieldValue} values={formik.values} />
                      <span className="w-form__error">{formik.errors.files}</span>
                    </div>

                    <div className="privacy-richiesta">
                      <Privacy formik={formik} isRegistrazione={true}></Privacy>
                    </div>
                    <div className="button-submit-richiesta">
                      <input
                        type="submit"
                        value="Continua"
                        disabled={!(formik.isValid && formik.dirty)}
                        className=" button button--primary"
                      />
                    </div>
                  </Form>
                </>
              )}
            </Formik>
          </div>
        </div>
      </main>
    </>
  )
}

export const getServerSideProps = async ({ res, req }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'pubblica-articolo',
      },
      headers,
    })
    const pagina = await pageResponse.data
    const toolbarProps = { toolbarPage: pagina }

    return { props: { pagina, ...toolbarProps } }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default PubblicaArticolo
